<template>
    <div>
        <vue-headful
                title="Falk Huth | Steckbrief"
                description="Steckbrief von Falk Huth"
        />
        <md-card md-with-hover>
            <md-ripple>
                <md-card-header>
                    <div class="md-title">Steckbrief</div>
                    <div class="md-subhead">
                        mit den wichtigsten Eckdaten und den Verweisen auf detailliertere Informationen
                    </div>
                </md-card-header>

                <md-card-content>
                    <div class="md-layout">
                        <div class="md-layout-item md-size-50 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                Aktuelle Situation
                            </md-subheader>
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td><md-icon class="platz-danach">home</md-icon></td>
                                    <td><span class="platz-danach">Wohnort:</span></td>
                                    <td colspan="2">
                                        <a href="https://www.halle.de/" target="_blank" >Halle (Saale)</a>
                                    </td>
                                </tr>
                                <tr>
                                    <td><md-icon class="platz-danach">business</md-icon></td>
                                    <td><span class="platz-danach">Arbeitsort:</span></td>
                                    <td colspan="2" v-if="getCurrentYear() == 2019">
                                        <a href="https://www.koethen-anhalt.de/" target="_blank">Köthen (Anhalt)</a>
                                    </td>
                                    <td colspan="2" v-else>
                                        <a href="https://www.leipzig.de/" target="_blank">Leipzig</a>
                                    </td>
                                </tr>
                                <tr><td colspan="4"><md-divider></md-divider></td></tr>
                                <tr>
                                    <td><md-icon class="platz-danach">event_seat</md-icon></td>
                                    <td><span class="platz-danach">angestellt:</span></td>
                                    <td>
                                        <div class="platz-am-ende" v-if="getCurrentYear() == 2019">
                                            <strong>Projektmanager ECM-System (DMS)</strong><br/>
                                            <a href="https://www.hs-anhalt.de" target="_blank">Hochschule Anhalt</a><br/>
                                                Anhalt University of Applied Sciences
                                        </div>
                                        <div class="platz-am-ende" v-else>
                                            <strong>Product Owner ECM/DMS Practice</strong><br/>
                                            <a href="https://www.ewerk.com" target="_blank">EWERK Group</a>
                                        </div>
                                    </td>
                                    <td>
                                        <md-button class="md-primary" to="/to/berufserfahrungen">
                                            <md-icon>zoom_in</md-icon>
                                            <md-tooltip md-direction="bottom">Berufserfahrungen und Praktika</md-tooltip>
                                        </md-button>
                                    </td>
                                </tr>
                                <tr>
                                    <td><md-icon class="platz-danach">school</md-icon></td>
                                    <td><span class="platz-danach">Abschluss:</span></td>
                                    <td>
                                        <div class="platz-am-ende">
                                            <strong>Diplom-Wirtschaftsinformatiker (FH)</strong><br/>
                                            <a href="https://www.fh-zwickau.de"
                                               target="_blank">Westsächsische Hochschule Zwickau</a>
                                        </div>
                                    </td>
                                    <td>
                                        <md-button class="md-primary" to="/to/ausbildungsdaten">
                                            <md-icon>zoom_in</md-icon>
                                            <md-tooltip md-direction="bottom">Ausbildungsdaten</md-tooltip>
                                        </md-button>
                                    </td>
                                </tr>
                                <tr><td colspan="4"><md-divider></md-divider></td></tr>
                                <tr v-if="show_projects">
                                    <td><md-icon class="platz-danach">list_alt</md-icon></td>
                                    <td><span class="platz-danach">bearbeitet:</span></td>
                                    <td>
                                        <div class="platz-am-ende">
                                            <strong>Vorstellung ausgewählter IT-Projekte</strong><br>
                                            Details durch Klick auf Zoom-Icon
                                        </div>
                                    </td>
                                    <td>
                                        <md-button class="md-primary" to="/to/projekte">
                                            <md-icon>zoom_in</md-icon>
                                            <md-tooltip md-direction="bottom">Vorstellung ausgewählter IT-Projekte</md-tooltip>
                                        </md-button>
                                    </td>
                                </tr>
                                <tr>
                                    <td><md-icon class="platz-danach">how_to_reg</md-icon></td>
                                    <td><span class="platz-danach">erworben:</span></td>
                                    <td>
                                        <div class="platz-am-ende">
                                            <strong>IT-, Prozess- und sonstige Kenntnisse</strong><br>
                                            Details über Zoom-Botton rechts
                                        </div>
                                    </td>
                                    <td>
                                        <md-button class="md-primary" to="/to/kenntnisse">
                                            <md-icon>zoom_in</md-icon>
                                            <md-tooltip md-direction="bottom">IT-, Prozess- und sonstige Kenntnisse (Auswahl)</md-tooltip>
                                        </md-button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="md-layout-item md-size-50 md-xsmall-size-100">
                            <md-subheader class="md-primary">
                                Kontaktdaten
                            </md-subheader>
                            <table border="0" cellpadding="0" cellspacing="0">
                                <tr>
                                    <td><md-icon class="platz-danach">phone_android</md-icon></td>
                                    <td><span class="platz-danach">Mobil:</span></td>
                                    <td>+49 177 2358270</td>
                                </tr>
                                <tr>
                                    <td><md-icon class="platz-danach">email</md-icon></td>
                                    <td><span class="platz-danach">E-Mail:</span></td>
                                    <td><router-link to="/to/kontakt">info@falk-huth.de</router-link></td>
                                </tr>
                                <tr><td colspan="3"><md-divider></md-divider></td></tr>
                                <tr>
                                    <td><md-icon class="platz-danach">person_add</md-icon></td>
                                    <td><span class="platz-danach">XING:</span></td>
                                    <td>
                                        <a href="https://www.xing.com/profile/Falk_Huth"
                                           target="_blank">https://www.xing.com/profile/Falk_Huth</a>
                                    </td>
                                </tr>
                                <tr>
                                    <td><md-icon class="platz-danach">insert_link</md-icon></td>
                                    <td><span class="platz-danach">LinkedIn:</span></td>
                                    <td>
                                        <a href="https://www.linkedin.com/in/falk-huth"
                                           target="_blank">https://www.linkedin.com/in/falk-huth</a>
                                    </td>
                                </tr>
                                <tr><td colspan="4"><md-divider></md-divider></td></tr>
                                <tr>
                                    <td><md-icon class="platz-danach">language</md-icon></td>
                                    <td><span class="platz-danach">Sprachen:</span></td>
                                    <td>
                                        <strong>deutsch</strong> (Muttersprache),
                                        <strong>englisch</strong> (fließend),<br/>
                                        <strong>französisch</strong> (gut),
                                        <strong>russisch</strong>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </md-card-content>
            </md-ripple>
        </md-card>
    </div>
</template>

<script>
    export default {
        name: "Start",
        data: () => ({
            // Dieser Teil ist entsprechend anzupassen. Nicht zutreffende Daten sind zu entfernen, fehlende zu ergänzen.
            show_related: false,
            show_projects: false,
        }),
        methods: {
            getCurrentYear() {
                return new Date().getFullYear();
            }
        },
    }
</script>

<style lang="scss" scoped>
    .md-subheader {
        padding-left: 0!important;
    }
    .platz-danach {
        margin-right: 10px;
    }
    .platz-am-ende {
        margin-right: 20px;
    }
    td {
        padding-bottom: 12px;
        vertical-align: top;
    }
</style>
